import {Component} from '@angular/core';
import {Util} from '../../shared/utils/Util';
import {TokenService} from '../../shared/services/token.service';
import {Router} from '@angular/router';
import {DesignPreferenceService} from '../../shared/services/design-preference.service';

@Component({
  selector: 'app-permission-path',
  templateUrl: './permission-path.component.html',
  styleUrls: ['./permission-path.component.scss']
})
export class PermissionPathComponent {

  constructor(tokenService: TokenService, router: Router, designPreference: DesignPreferenceService) {
    router.navigate([designPreference.landingUrl(Util.getRedirectionUrl(tokenService.getRolesFromToken()))]);
  }
}
